import { useSelector } from "react-redux";

import { User } from "pwapi";

import { caseSearchToURL } from "shared/actions/casesActions";

import Header from "components/header/Header";
import ApplicationState from "store/ApplicationState";

import { SlideHeaderProps } from "./SlideHeader";
import { SlideAdminLink } from "./SlideHeader/AdminLink";
import { HelpButton } from "./SlideHeader/HelpButton";
import { SlideLabelAndSource } from "./SlideHeader/SlideLabelAndSource";

const SlideHeaderCaseless = ({
  slideDetailObject,
  dialog,
  setDialog,
  specimen,
}: Omit<SlideHeaderProps, "caseDetailObject">) => {
  const currentUser: User | undefined = useSelector(
    ({ auth }: ApplicationState) => auth.user
  );

  const { currentCaseSearch: caseSearch } = useSelector(
    ({ cases }: ApplicationState) => cases
  );

  return (
    <Header
      logoType="simple"
      logoLink={caseSearchToURL(caseSearch, currentUser)}
      adminLink={<SlideAdminLink slideId={slideDetailObject.id!} />}
      helper={
        <div className="SlideHeader__helper">
          <HelpButton dialog={dialog} setDialog={setDialog} />
        </div>
      }
    >
      <div className="SlideHeader">
        <div className="SlideInfo">
          <div className="CaseInfo">
            <h1>Slide Has No Case</h1>
          </div>
          <SlideLabelAndSource
            specimen={specimen}
            slideDetailObject={slideDetailObject}
          />
        </div>
      </div>
    </Header>
  );
};
export default SlideHeaderCaseless;
